import { ColorUtils } from '../../../../../iupics-util/tools/color-utils';

export function getColorsForString(str: string): { bg: string; fg: string } {
  const hash = str
    .replace(' ', '')
    .split('')
    .reduce((acc, char) => {
      return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

  const normalizeHash = (_hash: number, min: number, max: number): number => {
    return Math.floor((_hash % (max - min)) + min);
  };

  const h = normalizeHash(hash, 0, 360);
  const s = normalizeHash(hash, 35, 85);
  const l = normalizeHash(hash, 65, 85);

  const bg = ColorUtils.hslToHex({ h, s, l });
  const fg = ColorUtils.getContrastColor(bg);

  return { bg, fg };
}

/**
 * If the account name has a space, return the first letter of the first word and the first letter of
 * the second word. If the account name has a dash, return the first letter of the first word and the
 * first letter of the second word. Otherwise, return the first two letters of the account name
 * @param {string} accountName - The account name of the user.
 * @returns The first two letters of the account name.
 */
export function getAvatarTwoLetters(accountName: string): string {
  const accountNameUpper = accountName.toUpperCase();

  const spacesSplit = accountNameUpper.split(' ');
  if (spacesSplit.length > 1) {
    return spacesSplit[0].charAt(0) + spacesSplit[1].charAt(0);
  }

  const dashSplit = accountNameUpper.split('-');
  if (dashSplit.length > 1) {
    return dashSplit[0].charAt(0) + dashSplit[1].charAt(0);
  }

  return accountNameUpper.charAt(0) + accountNameUpper.charAt(1);
}
